import React from 'react';

import './radiobutton.css';

export const RadioButton = props => {
  const { text, id, name, value, selected, onSelect, className } = props;
  return (
    <div className={'input-radio-button ' + id + ' '+ className}>
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        onClick={e => onSelect(e)}
      />
      <label className={selected ? 'label-active' : ''} htmlFor={id}>{text}</label>
      <div className={selected ? 'check active' : 'check'}>
        <div className="inside" />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/RadioButton/RadioButton.js